import { useTheme } from "../../../context/ThemeProvider";
import chatSidebarTime from "../../../utils/chatSidebarTime";
import TextTranslate from "../../../utils/TextTranslate";
import { useTimeFormatOptions } from "../../../hooks/useTimeFormatOptions";
import { useConversationDocuments } from "../../../store/api/useConversationDocuments";
import SearchNotFoundAnimation from "../../../components/SearchNotFoundAnimation";
import DocMessageBubble from "../../../components/DocMessageBubble";
import { resolveMediaSrc } from "../../../utils/mediaMessageUrl";

export default function Documents() {
  // @ts-ignore
  const { theme } = useTheme();
  const { translate, hour12 } = useTimeFormatOptions();
  const { data } = useConversationDocuments();
  const records = data?.data?.Records || [];

  if (!records.length) {
    return (
      <div className="grid min-h-[50vh] place-content-center gap-4 text-center">
        <SearchNotFoundAnimation />
        <div className="text-[15px] text-lightText">
          <TextTranslate text="No Document Found" />
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl bg-primary shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
      {records.map((message, index) => (
        <div
          key={message.message_id}
          className={`px-3 py-3 ${
            index > 0
              ? "border-t border-black/[0.06] dark:border-white/[0.08]"
              : ""
          }`}
        >
          <DocMessageBubble
            href={resolveMediaSrc(message)}
            fileNameRaw={message.message_length}
            fileSizeRaw={undefined}
            previewUrl={
              message.message_thumbnail || message.message_preview || null
            }
            blurHash={message.blur_hash || message.blurHash || null}
            isOwn={false}
            theme={theme}
          />
          <div className="mt-1.5 pl-[3.25rem] text-left text-[11px] text-lightText">
            {chatSidebarTime(message.createdAt, { translate, hour12 })}
          </div>
        </div>
      ))}
    </div>
  );
}
